import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

@Injectable()
export class InitGuard implements CanActivate {
  private initEnable = true

  canActivate(): boolean {
    return this.initEnable;
  }

  disableInit(): void {
    this.initEnable = false
  }
}
